export function widgetVariantMapper(variant, theme) {
    switch (variant) {
        case 'error':
            return {
                borderColor: theme.palette.error.light,
                iconColor: theme.palette.error.main,
            };
        case 'warning':
            return {
                borderColor: theme.palette.groupPrimary.orange100,
                iconColor: theme.palette.groupPrimary.orange100,
            };
        case 'purple':
            return {
                borderColor: theme.palette.purple.lighter,
                iconColor: theme.palette.purple.light,
            };
        case 'standard':
            return {
                borderColor: theme.palette.groupPrimary.sandStone,
                iconColor: theme.palette.secondary.contrastText,
            };
        case 'success':
            return {
                borderColor: theme.palette.success.light,
                iconColor: theme.palette.success.main,
            };
        case 'teal':
            return {
                borderColor: theme.palette.teal[100],
                iconColor: theme.palette.teal['A100'],
            };
        default:
            return {
                borderColor: theme.palette.groupPrimary.sandStone,
                iconColor: theme.palette.secondary.contrastText,
            };
    }
}
